import React, { useMemo } from "react";
import { JiraData } from "./jira.data";
import { DisplayData, DisplayDataProps, DisplayDataWidget, translateLabelForData } from "@me8eon/data";
import { IconAndTitle, IconTitleAndUrl, useAttributeValueComponents, useRenderers } from "@me8eon/renderers";
import { SimpleWidget } from "@me8eon/simple_widget";
// @ts-ignore
import JiraIcon from "./jira.svg";
import { useCommonComponents } from "@me8eon/components";

export const JiraDisplay: DisplayData<JiraData> =
    ({ rootId, id, data }: DisplayDataProps<JiraData>) => {
        const { H1WithIconAndUrl, Markdown, Url } = useRenderers();
        const { ClipHeight } = useCommonComponents();
        const { Text, Date, DataLayout } = useAttributeValueComponents();
        const newRootId = `${rootId}.${id}`;
        const issueSummaryAndUrl: IconTitleAndUrl = useMemo(() =>
            ({ url: data.url, title: `${data.issue}: ${data.summary}`, icon: JiraIcon }), [data.url, data.summary]);
        return <DataLayout rootId={newRootId} layout={[1, 1, 4, 1]}>
            <H1WithIconAndUrl rootId={newRootId} attribute={translateLabelForData("name")} value={issueSummaryAndUrl} />
            <ClipHeight maxHeight="3rem" force={false}>
                <Markdown rootId={id} attribute={translateLabelForData("description")} value={data.description} />
            </ClipHeight>
            <Text rootId={id} attribute={translateLabelForData("source")} value="jira" />
            <Text rootId={id} attribute={translateLabelForData("status")} value={data.status} />
            <Text rootId={id} attribute={translateLabelForData("createdBy")} value={data.created_by} />
            <Date rootId={id} attribute={translateLabelForData("lastUpdated")} value={data.last_updated} />
            <Url rootId={id} attribute={translateLabelForData("url")} value={data.url} />
        </DataLayout>;
    };

export const OneLineJiraDisplay: DisplayData<JiraData> =
    ({ data, listItemClicked }: DisplayDataProps<JiraData>) => {
        const { SearchListItem } = useRenderers();
        const issueSummaryAndUrl: IconAndTitle = useMemo(() =>
        ({
            title: `${data.issue}: ${data.summary}`,
            icon: JiraIcon,
            onClick: () => { listItemClicked && listItemClicked(`${data.issue} ${data.summary}`); },
        }), [data.summary]);
        return (
            <SearchListItem key={data.issue} rootId={data.issue} attribute={translateLabelForData("name")} value={issueSummaryAndUrl} />
        );
    };

export const SimpleJiraWidget: DisplayDataWidget<JiraData> =
    SimpleWidget(
        ["issue", "summary", "status"],
        ["issue", "summary", "status"],
        ["issue", "status"]);

